<template>
<div
  v-if="ticketsCustomer.length > 0"
  class="all-tickets-document-class"
>
  <div v-loading="loading">
    <div
      v-for="(value, index) in tickets"
      :key="index"
    >
      <ticket-document
        :loading="loading"
        :ticket="value"
      ></ticket-document>
      <div class="page-break"></div>
    </div>
  </div>
</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import TicketDocument from './TicketDocument'

export default {
  name: 'all-tickets-document',

  components: {
    TicketDocument
  },

  data () {
    return {
      ticketsCustomer: [],
      loading: true
    }
  },

  computed: {
    ...mapGetters('events', {
      event: 'event'
    }),
    ...mapGetters('customers', {
      customers: 'modelById'
    }),
    ...mapGetters('tickets', {
      tickets: 'tickets'
    }),
    eligibleNotWinners () {
      return this.$route.params.eligibleNotWinners
    },
    eventId () {
      return this.$route.params.id
    }
  },

  methods: {
    ...mapActions('events', {
      fetchEvent: 'fetchOne'
    }),
    ...mapActions('tickets', {
      fetchTickets: 'fetchAll',
      fetchTicket: 'fetchOne',
      setTickets: 'setStateAll'
    }),
    ...mapActions('customers', {
      fetchCustomersById: 'fetchIds'
    }),
    ...mapActions('project', { fetchProject: 'fetchOne' }),
    fetchData () {
      let where = null
      if (this.eligibleNotWinners === 'true') {
        where = {
          where: {
            eventId: this.eventId,
            winner: false,
            eligible: true
          },
          limit: 20
        }
      } else {
        where = {
          where: {
            eventId: this.eventId,
            winner: true
          },
          limit: 99999
        }
      }

      Promise.all([
        this.fetchEvent(this.eventId),
        this.fetchTickets(where)
      ]).then(results => {
        this.fetchCustomersById({
          connection: 'default',
          ids: this.tickets.map(item => {
            return Object.assign({}, { id: item.customerId })
          })
        }).then(customers => {
          this.tickets.forEach(ticket => {
            ticket.event = this.event
            ticket.customer = customers.find(customer => {
              return customer._id === ticket.customerId
            })
            this.ticketsCustomer.push(ticket)
          })
          this.loading = false
        })
      }).catch(error => {
        console.log(error)
      })
    }
  },

  mounted () {
    this.fetchProject('config')
    this.fetchData()
  }
}
</script>

<style scoped>
  @media print {
    .page-break {
      page-break-after: always;
    }
  }

  @page {
    size: A4 portrait;
    margin: 1em;  /* this affects the margin in the printer settings */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/AllTicketsDocument.vue